import {showUpgradeModal, UPGRADE_MODALS} from 'app/toasts/slice';

import {apiQuery} from '../api-query';
import {doesErrorMatch} from '../matchers';

import type {
  MutationLifecycleApi,
  QueryLifecycleApi,
} from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export function handleAccountLimitErrors(modalType: UPGRADE_MODALS) {
  return function (
    args: unknown,
    api:
      | QueryLifecycleApi<unknown, typeof apiQuery, unknown, 'sweetAPI'>
      | MutationLifecycleApi<unknown, typeof apiQuery, unknown, 'sweetAPI'>
  ): Promise<void> | void {
    const {dispatch, queryFulfilled} = api;

    queryFulfilled.catch((err) => {
      if (
        !err.isUnhandledError &&
        doesErrorMatch(err.error, 403, 'UPGRADE_REQUIRED')
      ) {
        dispatch(showUpgradeModal(modalType));
      }
    });
  };
}

export {UPGRADE_MODALS};
